import React from 'react';
import { CostsSubTitle, CostsWrapper, RowWrapper } from './Costs.styled';
import KPICard from '../KPICard/KPICard';
import { StyledTextInputAnalysis, SubPageTitle, KPIRow, SubmitButton, StyledForm, AddButton } from '../../pages/AnalysisPage/AnalysisPage.styled';
import { useSelector, useDispatch } from 'react-redux';
import { updateRecurringCosts, updateOneTimeCosts, updateElectricalPanelFlag } from '../../features/outputs/outputs';
import PopUp from '../PopUp/PopUp';
import { populateInputs, resetEnableReset } from '../../features/inputs/inputs';

function Costs () {
   const recurringCosts = useSelector((state) => state.inputs.value.costMonthlyArr);
   const oneTimeCosts = useSelector((state) => state.inputs.value.costOneTimeArr);
   const popup = useSelector((state) => state.outputs.value.electricalPanelFlag);
   const inputs = useSelector((state) => state.inputs.value);
   const dispatch = useDispatch();
   const baseOneTimeCosts = ["Hardware Cost", "Labor and Other Costs", "Panel Upgrade Costs"];
   const baseRecurringCosts = ["Monthly Networking Cost"];

   const handleClose = () => dispatch(updateElectricalPanelFlag(false));

   const handleAdd = (event, costList) => {
      event.preventDefault();
      event.target[0].value = event.target[0].value.replace('$', '');
      event.target[0].value = event.target[0].value.replace(',', '');
      const costObj = 
      {
         isTotal: false,
         number: Number(event.target[0].value),
         label: event.target[1].value
      }
      if (costList === recurringCosts) {
         dispatch(updateRecurringCosts([costObj, ...recurringCosts]));
         dispatch(populateInputs({...inputs, costMonthlyArr: [...inputs.costMonthlyArr, {amount: costObj.number, title: costObj.label}]}));
         dispatch(resetEnableReset(true));
         document.getElementById("monthlyCostsForm").reset();
      } else {
         dispatch(updateOneTimeCosts([costObj, ...oneTimeCosts]));
         dispatch(populateInputs({...inputs, costOneTimeArr: [...inputs.costOneTimeArr, {amount: costObj.number, title: costObj.label}]}));
         dispatch(resetEnableReset(true));
         document.getElementById("oneTimeCostsForm").reset();
      }
   }

   const handleRemove = (event, costList, costToRemove) => {
      const costObj = 
      {
         isTotal: false,
         number: Number(costToRemove.amount),
         label: costToRemove.title
      }
      if (costList === recurringCosts) {
         dispatch(updateRecurringCosts(recurringCosts.filter((cost) => cost !== costObj)));
         dispatch(populateInputs({...inputs, costMonthlyArr: inputs.costMonthlyArr.filter((cost) => cost !== costToRemove)}));
         dispatch(resetEnableReset(true));
      } else {
         dispatch(updateOneTimeCosts(oneTimeCosts.filter((cost) => cost !== costObj)));
         dispatch(populateInputs({...inputs, costOneTimeArr: inputs.costOneTimeArr.filter((cost) => cost !== costToRemove)}));
         dispatch(resetEnableReset(true));
      }
   }

   return (
   <>
      <CostsWrapper>
      <div>This tab shows estimated costs without considering rebates or incentives. This tool assumes there are not utility upgrade costs required for this project, such as line or panel upgrades. If you have an estimate for those costs, please add them below. <b>To retrieve initial costs, click "Reset" above.</b></div>
      <SubPageTitle>One-Time Costs</SubPageTitle>
         <KPIRow width="75%">
         <KPICard key={oneTimeCosts.length} isTotal={true} number={`$${oneTimeCosts.map((cost) => cost.amount).reduce((accumulator, currentValue) => accumulator + currentValue, 0).toLocaleString('en', { maximumFractionDigits: 0, useGrouping: true})}`} label={"Total One-Time Costs"} />
            {oneTimeCosts.map((cost, index) => (
               <KPICard key={index} isTotal={false} allowRemove={true} number={`$${cost.amount.toLocaleString(undefined, {maximumFractionDigits: 0})}`} label={cost.title} handleRemove= {(e) => handleRemove(e, oneTimeCosts, cost)} />
            ))}
         </KPIRow>
         <CostsSubTitle>Additional One-Time Costs</CostsSubTitle>
         Please add any additional one-time costs that you would like to include in the total.
         {baseOneTimeCosts.map((cost) => oneTimeCosts.map((innerCost) => innerCost.title).includes(cost) ? null :
         <StyledForm 
            width='50%' 
            onSubmit={(e) => handleAdd(e, oneTimeCosts)}
            id="oneTimeCostsForm"
         >
            <StyledTextInputAnalysis
                  id="oneTimeCosts"
                  placeholder="$"
                  width='10%'
            />
            <StyledTextInputAnalysis
                  id="oneTimeCostDescription"
                  defaultValue={cost}
                  readOnly={true}
                  width='50%'
            />
            <AddButton type="submit">Add</AddButton>
            </StyledForm>
         )}
         <StyledForm 
            width='50%' 
            onSubmit={(e) => handleAdd(e, oneTimeCosts)}
            id="oneTimeCostsForm"
         >
            <StyledTextInputAnalysis
                  id="oneTimeCosts"
                  placeholder="$"
                  width='10%'
            />
            <StyledTextInputAnalysis
                  id="oneTimeCostDescription"
                  placeholder="Description"
                  aria-label='Description'
                  width='50%'
            />
            <AddButton type="submit">Add</AddButton>
            </StyledForm>
         <RowWrapper>
         </RowWrapper>
         <SubPageTitle>Recurring Costs</SubPageTitle>
         <KPIRow width='50%'>
         <KPICard key={recurringCosts.length} isTotal={true} number={`$${recurringCosts.map((cost) => cost.amount*12).reduce((accumulator, currentValue) => accumulator + currentValue, 0).toLocaleString(undefined, { maximumFractionDigits: 0})}`} label={"Total Annual Costs"} />
            {recurringCosts.map((cost, index) => (
               <KPICard key={index} isTotal={false} allowRemove={true} number={`$${cost.amount.toLocaleString(undefined, { maximumFractionDigits: 0})}`} label={cost.title} handleRemove= {(e) => handleRemove(e, recurringCosts, cost)} />
            ))}
         </KPIRow>
         <CostsSubTitle>Additional Recurring Costs</CostsSubTitle>
         Please add any additional monthly costs that you would like to include in the total.
         {baseRecurringCosts.map((cost) => recurringCosts.map((innerCost) => innerCost.title).includes(cost) ? null :
         <StyledForm 
            width='50%' 
            onSubmit={(e) => handleAdd(e, recurringCosts)}
            id="monthlyCostsForm"
         >
            <StyledTextInputAnalysis
                  id="monthlyCosts"
                  placeholder="$"
                  width='10%'
            />
            <StyledTextInputAnalysis
                  id="monthlyCostDescription"
                  defaultValue={cost}
                  readOnly={true}
                  width='50%'
            />
            <AddButton type="submit">Add</AddButton>
            </StyledForm>
         )}
            <StyledForm width='50%' 
                        onSubmit={(e) => handleAdd(e, recurringCosts)}
                        id="monthlyCostsForm"
            >
               <StyledTextInputAnalysis
                     id="monthlyCosts"
                     placeholder="$"
                     width={'10%'}
               />
               <StyledTextInputAnalysis
                     id="monthlyCostDescription"
                     placeholder="Description"
                     aria-label='Description'
                     width={'50%'}
               />
               <AddButton type="submit">Add</AddButton>
            </StyledForm>

      </CostsWrapper>
   </>

   )};

Costs.propTypes = {};

Costs.defaultProps = {};

export default Costs;
